/** One bulk menu for the Visit board: each command family offers itself, and the board's one handler routes by id. */
import { VisitBrowseRow } from '@jms/model';
import { Command } from '@workbuddy/ui/model';
import type { BulkCommandArgs, BulkCommandOutcome, EntityBoardBulkCommandsArgs } from '@workbuddy/ui/v2/blocks/entity.board/context';
import { runVisitOverdueRescheduleBulk, runVisitOverdueSkipBulk, VISIT_OVERDUE_RESCHEDULE_BULK_ID, VISIT_OVERDUE_SKIP_BULK_ID, visitOverdueBulkCommands } from './visit.overdue.bulk.command';
import { runVisitRemoveFromApprovalBulk, VISIT_REMOVE_FROM_APPROVAL_BULK_ID, visitRemoveFromApprovalBulkCommands } from './visit.remove.from.approval.command';
import { runVisitRetryJobCreationBulk, VISIT_RETRY_JOB_CREATION_BULK_ID, visitRetryJobCreationBulkCommands } from './visit.retry.job.creation.command';

type VisitBulkHandler = (args: BulkCommandArgs<VisitBrowseRow>) => Promise<BulkCommandOutcome | false>;

const HANDLERS: Readonly<Record<string, VisitBulkHandler>> = {
  [VISIT_REMOVE_FROM_APPROVAL_BULK_ID]: runVisitRemoveFromApprovalBulk,
  [VISIT_OVERDUE_RESCHEDULE_BULK_ID]: runVisitOverdueRescheduleBulk,
  [VISIT_OVERDUE_SKIP_BULK_ID]: runVisitOverdueSkipBulk,
  [VISIT_RETRY_JOB_CREATION_BULK_ID]: runVisitRetryJobCreationBulk,
};

export function visitBulkCommands(args: EntityBoardBulkCommandsArgs<VisitBrowseRow>): Command[] {

  return [...visitRemoveFromApprovalBulkCommands(args), ...visitOverdueBulkCommands(args), ...visitRetryJobCreationBulkCommands(args)];
}

/** Unknown ids fall through, so metadata-provided bulk actions keep their default handling. */
export async function handleVisitBulkCommand(args: BulkCommandArgs<VisitBrowseRow>): Promise<BulkCommandOutcome | false> {

  return HANDLERS[args.action]?.(args) ?? false;
}
